import React from "react";
import { Button, Dialog } from "@mui/material";
import DisabledClickLoading from "../../components/DisabledClickLoading";
import { useAppState } from "../../states/app-state";
import styles from './CancelTransportBeforePayment.module.scss' // added by Bearer Web Developer
// useStyles removed by Bearer Web Developer


interface IAllowCancellationTransportBeforePaymentProps { open: boolean, handleClose: () => void }
const AllowCancellationTransportBeforePayment: React.FC<IAllowCancellationTransportBeforePaymentProps> = ({ open, handleClose }) => {
    
    const [loading, setLoading] = React.useState(false);
    const appState = useAppState();
    const handleCancel = async () => {
        try {
            setLoading(true);
            await appState.selectedOrder?.payment.customerCancelTransportBeforePayment();
            handleClose();
        } catch (err) {
            setLoading(false);
        }
    }
    // modified by Bearer Web Developer start
    return (
        <Dialog open={open} PaperProps={{ style: { borderRadius: "10px" } }}>
            <div className={styles.allow_cancellation}>
                <p>Are you sure you want to cancel this order?</p>
                <div className={styles.confirm}>
                    <Button onClick={handleClose} disableRipple={true} className={styles.no}><span>No</span></Button>
                    <Button onClick={handleCancel}  disabled={loading} disableRipple={true} className={styles.yes}><span>Yes</span></Button>
                    {loading && <DisabledClickLoading />}
                </div>
            </div>
        </Dialog>
    )
    // modified by Bearer Web Developer end
}
export default AllowCancellationTransportBeforePayment;



